const SDK_VERSION = '7.17.3';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
